import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    provideRouter,
    RouteReuseStrategy,
    withInMemoryScrolling,
} from '@angular/router';
import { provideFuse } from '@fuse';
import { fuseLoadingInterceptor } from '@fuse/services/loading';
import { appRoutes } from 'app/app.routes';
import { apiInterceptor } from 'app/core/api/api.interceptor';
import { authRefreshInterceptor } from 'app/core/auth/auth-refresh.interceptor';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { RecordReuseStrategy } from 'app/core/routing/record-reuse.strategy';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),

        // The one HTTP client, with every interceptor. Order matters - the first runs outermost:
        // apiInterceptor prefixes the API host and turns a failure into one message, so it must
        // see an error only after authRefreshInterceptor has had its chance to refresh a 401.
        provideHttpClient(
            withInterceptors([
                apiInterceptor,
                authRefreshInterceptor,
                authInterceptor,
                fuseLoadingInterceptor,
            ])
        ),
        provideRouter(
            appRoutes,
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),

        // Another record in the address makes its page afresh, rather than keeping the last one's.
        { provide: RouteReuseStrategy, useClass: RecordReuseStrategy },

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        provideAuth(),
        provideIcons(),
        provideFuse({
            fuse: {
                layout: 'classy',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'RiNico',
                    },
                ],
            },
        }),
    ],
};
